import React, {Component} from 'react';
import Page from "../../components/Page/Page";
import classes from './About.module.scss';
import COLORS from "../../styles/colors";
import {DefaultNavbar} from "../../components/Navbar/Navbar";
import Typography from "../../components/Typography/Typography";
import Icon, {ICONS} from "../../components/Icon/Icon";
import Button from "../../components/Button";
import {openUrl} from "../../utilities";
import classNames from "classnames";
import Navigator from "../../components/Navigator/Navigator";
import Inspector from "../../components/Inspector";
import {connect} from "react-redux";
import {
	addNavActions,
	NAV_ACTIONS,
	NAV_ITEMS,
	removeNavActions,
	setNavBar
} from "../../components/NavController/NavController";

const CONTENT = [
	{
		icon: ICONS.StudioProba,
		iconWidth: 170,
		body: (
			<>
				Founded in 2013 by Alex Proba, Studio Proba is a Portland and Brooklyn-based multidisciplinary design
				studio focusing on brand design, art direction, product design, illustration and murals.
			</>
		),
		link: 'https://studioproba.com',
	},
	{
		icon: ICONS.Enjoy,
		iconWidth: 32,
		body: (
			<>
				Enjoy the Weather is a contemporary design practice based out of Portland, Oregon. Known for their
				digital experiences with the likes of Nike, the studio designs and builds objects, spaces, and products
				that capture the imagination.
			</>
		),
		link: 'http://enjoytheweather.com',
	},
	{
		icon: ICONS.MDD,
		iconWidth: 138,
		body: (
			<>
				We are a creative neighborhood & shopping destination dedicated to innovative fashion, design, art,
				architecture, & dining.
			</>
		),
		link: 'https://www.miamidesigndistrict.net/',
	},
	{
		header: (
			<Typography type={'h3'} className={classes.beyond}>
				Art Week<br/>
				Top 20
			</Typography>
		),
		iconWidth: 96,
		body: (
			<>
				Discover our list of must-see Miami Art Week exhibitions, on view November 30th thru December 5th, 2021.
			</>
		),
	},
]

class About extends Component {
	state = {
		onboardingOpen: false,
	}

	componentDidMount() {
		setNavBar(this.props.dispatch, {
			color: COLORS.WINE,
			right: NAV_ITEMS.INFO,
			fixed: true,
		});

		this.handler = addNavActions({
			[NAV_ACTIONS.ONBOARDING_OPENED]: this.onboardingOpen,
			[NAV_ACTIONS.ONBOARDING_CLOSED]: this.onboardingClose,
		});
	}

	componentWillUnmount() {
		removeNavActions(this.handler);
	}

	getVersion = () => window?.APP_VERSION ?? 'vX.X.X';

	onboardingOpen = () => {
		this.setState({
			onboardingOpen: true,
		})
	}

	onboardingClose = () => {
		this.setState({
			onboardingOpen: false,
		})
	}

	render() {
		const {onboardingOpen} = this.state;

		return (
			<Page
				backgroundColor={COLORS.GREY}
				transition={'fade'}
				className={classes.root}
			>
				<Background/>

				<div className={classNames(classes.topSection, onboardingOpen && classes.hideText)}>
					<Typography type={'h2'} className={classes.title}>
						About
					</Typography>

					<Typography type={'h3'} className={classes.subtitle}>
						A participatory art<br/>
						installation by Studio <br/>
						Proba × Enjoy the <br/>
						Weather
					</Typography>
				</div>

				<div className={classes.content}>
					{CONTENT.map((data) => <Content {...data} />)}

					<div className={classes.version}>
						{this.getVersion()}
					</div>
				</div>
			</Page>
		);
	}
}

const Content = ({icon, body, link, iconWidth, header}) => {
	return (
		<div className={classes.item}>
			{
				icon && (
					<Icon
						icon={icon}
						className={classes.icon}
						width={`${iconWidth}px`}
					/>
				)
			}

			{
				header && header
			}
			<div className={classes.body}>
				{body}
			</div>
			{
				link && (
					<Button
						className={classes.button}
						type={'outlined'}
						color={'dimmed'}
						small
						onClick={() => {
							openUrl(link)
						}}
					>
						Visit Website
					</Button>
				)
			}
		</div>
	)
}

const Background = () => {
	return (
		<div className={classes.backgroundContainer}>
			<svg className={classes.background} viewBox="0 0 375 2279" fill="none"
				 xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_63:133)">
					<rect width="375" height="2279" fill="white"/>
					<path
						d="M-28.8472 653.836C4.83897 644.358 38.5252 634.957 72.2918 625.479C88.1299 621.009 104.129 616.54 118.279 608.757C161.854 584.792 178.013 536.014 189.832 491.243C196.665 465.351 203.097 439.46 209.207 413.414C211.539 403.473 213.79 393.07 210.896 383.13C208.001 373.343 200.283 365.175 192.163 358.163C161.05 331.269 120.771 315.01 80.5726 300.986C15.9337 278.484 -44.4442 260.684 -113.344 257.602C-129.665 286.267 -142.769 313.7 -158.527 340.131C-200.253 410.1 -246.159 496.329 -287.885 566.221C-292.307 573.619 -167.531 629.64 -155.472 636.729C-111.173 662.467 -80.1403 668.169 -28.8472 653.836Z"
						fill="#FF2433"/>
					<path
						d="M110.802 282.953C117.394 298.057 135.644 312.312 146.659 324.95C156.548 336.278 170.054 340.285 183.722 346.604C197.872 353.153 211.217 363.479 226.493 367.872C239.276 371.57 254.149 371.031 267.334 373.189C271.515 373.882 275.535 375.115 279.555 376.271C284.137 377.581 288.72 378.737 293.543 378.891C314.849 379.507 340.174 366.176 356.253 353.693C370.885 342.365 386.16 328.341 394.441 311.773C402.401 295.822 402.963 276.789 405.375 259.296C409.315 229.783 403.928 199.961 389.618 173.299C383.266 161.432 377.96 151.723 369.197 140.857C362.845 133.074 354.484 121.67 345.721 115.89C328.757 109.263 310.025 112.577 292.338 108.801C267.415 103.484 241.446 105.873 218.131 114.812C186.536 126.756 151.322 148.64 127.685 171.681C97.6169 200.886 93.597 243.885 110.802 282.953ZM199.238 225.853C207.921 196.339 260.983 173.376 290.408 176.921C311.15 179.387 334.626 192.718 344.033 211.52C345.48 222.616 350.947 233.096 340.495 244.347C333.018 252.361 313.562 258.14 303.915 263.457C286.871 272.859 263.716 289.118 243.698 287.808C208.484 285.573 189.591 258.757 199.238 225.853Z"
						fill="#FFA7FF"/>
					<path
						d="M315.009 463.79C274.49 480.049 242.813 516.036 208.886 541.619C130.901 600.338 50.9868 658.594 -21.6114 723.477C-42.193 741.894 -62.2921 764.087 -84.2404 778.497C-90.8329 782.812 -98.3902 785.278 -104.902 790.287C-94.7724 789.362 -85.0444 809.629 -76.9243 817.643C-47.4991 846.771 -6.9792 870.351 28.5561 892.312C95.2854 933.693 236.623 957.966 310.346 919.668C369.277 889.076 397.818 820.109 411.807 761.929C421.053 723.554 421.696 679.323 412.772 640.948C404.491 604.961 381.095 577.76 364.453 545.549C352.072 521.353 335.269 485.212 315.009 463.79Z"
						fill="#D79A34"/>
					<path
						d="M372.691 812.803C280.547 853.859 104.189 827.838 20.8779 783.477C14.0525 779.842 7.02623 776.125 0 772.407V2396H375V811.812C374.197 812.142 373.394 812.472 372.691 812.803Z"
						fill="#D79A34"/>
					<path
						d="M97.8598 -95.0272C101.86 -96.1772 105.02 -96.4372 108.95 -95.0972C104.86 -95.2772 106.5 -94.8372 109.35 -93.3172C114.26 -93.8972 126.41 -92.5872 130.79 -90.0972C132.36 -89.8672 135.69 -90.4872 136.03 -88.8372C137.27 -88.2972 133.12 -89.3072 135.03 -88.0472C145.54 -90.0472 156.39 -82.7972 166.93 -79.7972C169.51 -77.5472 176.02 -77.2572 171.31 -76.0772C176.38 -73.7272 183.56 -70.7272 185.44 -65.7672C187.75 -62.5172 197.1 -59.3072 195.44 -53.2372C197.01 -49.9972 202.2 -45.4572 197.84 -50.8572C204.03 -45.2672 197.84 -51.5072 197.05 -52.9472C202.55 -51.2572 202.05 -42.4372 205.75 -37.1472C203.75 -38.9172 207.81 -33.5972 207.47 -33.8672C207.47 -33.2772 207.11 -32.7372 206.9 -33.3772C208.78 -30.1072 206.7 -31.2172 208.19 -26.6972C206.32 -11.7772 209.57 0.612823 214.19 15.5428C223.79 26.0528 214.4 53.1528 211.49 61.9028C209.1 75.2128 199.75 97.1428 193.74 99.5928C193.37 100.023 189.93 108.183 184.47 114.383C186.62 108.683 180.59 117.913 181.47 117.563C171.61 126.263 167.58 134.803 161.2 138.273C159.61 140.693 161.85 138.043 161.66 139.273C160.33 138.643 157.96 142.913 155.57 144.113C156.01 145.223 155.95 144.883 154.27 146.113C154.46 147.233 154.61 147.323 152.8 147.203C149.6 147.803 151.63 149.573 149.11 151.333C148.41 150.713 143.56 157.793 143.69 154.963C138.69 159.493 129.69 163.343 125.3 170.963C125.49 169.233 127.96 166.893 124.7 168.063C126.25 167.753 124.16 169.013 123.29 169.513C127.45 168.513 124.97 170.513 121.56 173.303C115.93 175.653 119.2 171.043 114.07 174.783C104.78 178.593 94.6498 178.943 83.7298 181.023C53.6198 173.373 40.3398 152.603 20.0498 138.663C20.2498 134.663 7.96982 121.863 16.2098 132.293C14.7398 136.053 10.8098 125.043 10.6398 124.753C9.63982 121.263 4.47982 118.463 6.63982 115.073C10.3298 124.783 8.97982 117.433 5.24982 112.173C-0.630179 105.563 -6.97018 100.963 -14.2402 94.3428C-31.3902 73.5528 -35.6002 43.4828 -25.8602 15.4128C-24.6602 -4.79717 -13.5402 -30.3672 1.59982 -47.4472C7.46982 -52.7272 26.4198 -71.0472 38.5998 -73.4472C33.5098 -72.4472 38.5998 -73.4472 38.4698 -74.8572C39.9198 -76.0672 39.1998 -74.1072 42.0898 -75.8572C42.3898 -75.5572 40.0398 -74.2972 41.2598 -74.4072L46.2598 -76.0572C49.1498 -85.3672 81.8498 -91.5472 82.0198 -93.0572C89.8998 -95.7772 87.0798 -95.0572 81.3598 -91.6672C88.4198 -95.2572 92.4698 -93.3172 97.8598 -95.0272ZM12.8598 129.193C12.7198 129.193 13.2298 130.903 14.0698 130.643C13.4498 130.293 13.1498 129.483 12.8298 129.193H12.8598ZM142.86 155.193L142.63 155.383C142.66 155.373 142.7 155.263 142.78 155.183L142.86 155.193Z"
						fill="#B9AEF6"/>
				</g>
				<defs>
					<clipPath id="clip0_63:133">
						<rect width="375" height="2279" fill="white"/>
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default connect()(About);
